import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstancehlive1cpt4pr as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.v2s_1.z2s(6);
  if ($this.v2s_1.a2t() === 4) {
    $this.v2s_1.o2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.v2s_1.b2t()) {
    var key = $this.w2s_1 ? $this.v2s_1.d2t() : $this.v2s_1.c2t();
    $this.v2s_1.z2s(5);
    var element = $this.e2t();
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.v2s_1.f2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.v2s_1.o2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.v2s_1.z2s(7);
  } else if (lastToken === 4) {
    if (!$this.x2s_1) {
      invalidTrailingComma($this.v2s_1);
    }
    $this.v2s_1.z2s(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.v2s_1.z2s(6);
  if ($this.v2s_1.a2t() === 4) {
    $this.v2s_1.o2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.v2s_1.b2t()) {
    var key = $this.w2s_1 ? $this.v2s_1.d2t() : $this.v2s_1.c2t();
    $this.v2s_1.z2s(5);
    var element = yield* $receiver.ps(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.v2s_1.f2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.v2s_1.o2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.v2s_1.z2s(7);
  } else if (lastToken === 4) {
    if (!$this.x2s_1) {
      invalidTrailingComma($this.v2s_1);
    }
    $this.v2s_1.z2s(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.v2s_1.f2t();
  if ($this.v2s_1.a2t() === 4) {
    $this.v2s_1.o2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.v2s_1.b2t()) {
    var element = $this.e2t();
    result.i2(element);
    lastToken = $this.v2s_1.f2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.v2s_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.s2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.o2r(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.v2s_1.z2s(9);
  } else if (lastToken === 4) {
    if (!$this.x2s_1) {
      invalidTrailingComma($this.v2s_1, 'array');
    }
    $this.v2s_1.z2s(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.w2s_1 || !isString) {
    tmp = $this.v2s_1.d2t();
  } else {
    tmp = $this.v2s_1.c2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.g2t_1 = this$0;
      }
      *h2t($this$DeepRecursiveFunction, it, $completion) {
        var tmp0_subject = this.g2t_1.v2s_1.a2t();
        var tmp;
        if (tmp0_subject === 1) {
          tmp = readValue(this.g2t_1, true);
        } else if (tmp0_subject === 0) {
          tmp = readValue(this.g2t_1, false);
        } else if (tmp0_subject === 6) {
          tmp = yield* /*#__NOINLINE__*/readObject_0(this.g2t_1, $this$DeepRecursiveFunction, $completion);
        } else if (tmp0_subject === 8) {
          tmp = readArray(this.g2t_1);
        } else {
          this.g2t_1.v2s_1.o2r("Can't begin reading element, unexpected token");
        }
        return tmp;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.h2t(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.h2t($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.v2s_1 = lexer;
        this.w2s_1 = configuration.s2n_1;
        this.x2s_1 = configuration.e2o_1;
        this.y2s_1 = 0;
      }
      e2t() {
        var token = this.v2s_1.a2t();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.y2s_1 = this.y2s_1 + 1 | 0;
          if (this.y2s_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.y2s_1 = this.y2s_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.v2s_1.o2r('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
